<template>
  <issue-form ref="issueForm"></issue-form>
</template>

<script>
import IssueForm from "./Form";

export default {
  components: {
    IssueForm
  }
};
</script>
